/*

	お知らせページのベース

*/
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApplicationTemplate from "common/layouts/application/index"
import Accordion from "./components/Accordion"
import Banner from "applications/information/features/Banner"
import { useGetAcceptDate } from "common/hooks/gqlHooks";
import { useAuth } from "hooks/useAuth";
import "./style.css"

export default function Information() {
  const navigate = useNavigate();
  const { authStatus, user } = useAuth();
  const { data: acceptData, fetching: acceptDataFetching, error: acceptDataError, fetchAcceptDate } = useGetAcceptDate();

  useEffect(() => {
    if (authStatus === "authenticated" && user) {
      fetchAcceptDate();
    }
  }, [authStatus, user]);
  useEffect(() => {
    if (!acceptData) return;

    const termsAcceptDate = new Date(acceptData?.getAccountData?.termsAcceptDate || 0);
    const updateDate = new Date(acceptData?.getTerms?.updateDate);

    if (updateDate > termsAcceptDate) {
      navigate("/information/terms_of_service", {
        state: { contentOfTerms: acceptData.getTerms },
        replace: true
      });
    }
  }, [acceptData]);

  return (
    <ApplicationTemplate>
      <Accordion />
      <Banner />
    </ApplicationTemplate>
  )
}
